import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { class: "mt-4 text-muted-foreground" }

import { Spinner } from '@/components/ui/spinner';

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useMainStore } from '../store';
import { useRouter, useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginOidcCallback',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useMainStore();

const statusMessage = ref('Завершение входа через SSO...');

onMounted(async () => {
  const code = route.query.code as string;
  if (!code) {
    await router.replace({ name: 'login', query: { error: 'oidc' } });
    return;
  }

  try {
    const res = (await axios.post('/api/auth/oidc/exchange/', { code })).data;
    store.login({ access: res.access, refresh: res.refresh });
    await store.setCurrentUserName(res.username);

    const next = route.query.next as string;
    if (next) {
      await router.replace(next);
    } else {
      await router.replace('/');
    }
  } catch {
    statusMessage.value = 'Не удалось завершить вход';
    await router.replace({ name: 'login', query: { error: 'oidc' } });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Spinner)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(statusMessage.value), 1)
    ])
  ]))
}
}

})